import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { brl } from "./PurchaseDialog";

export const AdminTransfers = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/transfers").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);
  const list = items || [];
  return (
    <Card className="p-6" data-testid="admin-transfers">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <div className="font-display text-lg font-bold">Transferências entre usuários</div>
          <p className="text-xs text-muted-foreground">Taxa de {brl(1)} por transferência, cobrada do remetente.</p>
        </div>
        <div className="text-xs text-muted-foreground" data-testid="admin-transfers-totals">
          {list.length} transferência{list.length === 1 ? "" : "s"} · Total: <b className="font-mono text-foreground">{brl(list.reduce((a, t) => a + t.amount, 0))}</b> ·
          Taxas: <b className="font-mono text-foreground">{brl(list.reduce((a, t) => a + t.fee, 0))}</b>
        </div>
      </div>
      {!items ? <p className="text-sm text-muted-foreground">Carregando...</p> : list.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="admin-transfers-empty">Nenhuma transferência ainda.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[620px]" data-testid="admin-transfers-list">
            <thead className="text-xs uppercase tracking-wider text-muted-foreground">
              <tr className="border-b border-border">
                <th className="text-left py-2">Data</th><th className="text-left">Remetente</th><th className="text-left">Destinatário</th>
                <th className="text-right">Valor</th><th className="text-right">Taxa</th>
              </tr>
            </thead>
            <tbody>
              {list.map((t) => (
                <tr key={t.id} className="border-b border-border/50" data-testid={`transfer-row-${t.id}`}>
                  <td className="py-2 text-xs text-muted-foreground">{new Date(t.created_at).toLocaleString("pt-BR")}</td>
                  <td>{t.from_name}<div className="text-[11px] font-mono text-muted-foreground">{t.from_code}</div></td>
                  <td>{t.to_name}<div className="text-[11px] font-mono text-muted-foreground">{t.to_code}</div></td>
                  <td className="text-right font-mono">{brl(t.amount)}</td>
                  <td className="text-right font-mono text-muted-foreground">{brl(t.fee)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};
